import React from "react";
import SectionContainer from "../../SectionContainer/SectionContainer";
import Slider2 from "./Slider2";

const SectionOne = () => {
  return (
    <SectionContainer whiteBG={true}>
      <Slider2 key={"h"} />
    </SectionContainer>
  );
};

export default SectionOne;
